export default {
      id: "wrist-left-usage",
      viewBox: "0 0 27 41",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#wrist-left",
      toString: function () {
        return this.url;
      }
    }